module.exports = __webpack_public_path__ + "img/Email.2b77bb07.svg";